export enum FrameType{
    NONE = "none",
    POLAROID = "polaroid",
    REGULAR = "solid",
    ZEBRA = "zebra",
    HOOK = "hook",
    LUMBER = "lumber",
}
